var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRightMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5571 12.1172C14.5961 12.1562 14.5961 12.2194 14.5571 12.2585L7.58442 19.2452C7.29182 19.5384 7.2923 20.0132 7.58549 20.3058C7.87867 20.5984 8.35355 20.5979 8.64614 20.3048L16.2184 12.7174C16.511 12.4242 16.5105 11.9493 16.2173 11.6567C16.2159 11.6553 16.2145 11.6539 16.2131 11.6525L8.64586 4.0769C8.35313 3.78384 7.87825 3.78358 7.5852 4.07631C7.29214 4.36904 7.29188 4.84391 7.58461 5.13697L14.5571 12.1172Z",
    fill: "#484B53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightMedium);
export default __webpack_public_path__ + "static/media/chevron-right-medium.c950949e7f4c361d7a9dd3eed55eb9a3.svg";
export { ForwardRef as ReactComponent };